import { gql, useQuery } from '@apollo/client';
import { ParkAvailability } from 'apollo/types';

const LIST_PARK_AVAILABILITY = gql`
  query listParkAvailability {
    listParkAvailability {
      aperture
      closure
      isWinterTime
      startDate
      endDate
    }
  }
`;

const useListParkAvailabilityQuery = () => {
  return useQuery<{ listParkAvailability: ParkAvailability[] }>(LIST_PARK_AVAILABILITY);
};

export const useParkScheduleQuery = () => {
  const { data, ...rest } = useListParkAvailabilityQuery();
  const seasons = data?.listParkAvailability;

  return {
    ...rest,
    summerSchedule: seasons?.find((season) => !season.isWinterTime),
    winterSchedule: seasons?.find((season) => season.isWinterTime),
  };
};

export default useListParkAvailabilityQuery;
